import { Utils } from "../../shared/constants/utilities.constants";
import { FeatureFilter } from "./models/feature-filter.model";

export const getRangeFilter = (featureId: string, rangeFrom: string, rangeTo: string, prevFilters: FeatureFilter[]): FeatureFilter[] => {
    const existingFilterIndex = prevFilters.findIndex(f => f.featureId === featureId);
    let updatedFilters;
    if (existingFilterIndex >= 0) {
        updatedFilters = [...prevFilters];
        updatedFilters[existingFilterIndex] = {
            ...updatedFilters[existingFilterIndex],
            rangeFrom,
            rangeTo,
            valueType: "range"
        };
    } else {
        updatedFilters = [
            ...prevFilters,
            {
                featureId,
                rangeFrom,
                rangeTo,
                valueType: "range"
            }
        ];
    }
    return updatedFilters.filter(x => !Utils.isNullOrUndefined(x.featureId));
}